import { TextField } from '@mui/material'
import React from 'react'
import { bool, any } from 'prop-types'
const BaseTextfield = ({ upperCase = false, value, ...rest }) => {
  const trasform = {
    true: value => {
      if (typeof value === 'string') {
        return value.toUpperCase()
      }
      return value
    },
    false: value => value
  }

  return <TextField value={trasform[upperCase](value)} {...rest} />
}

BaseTextfield.propTypes = {
  upperCase: bool,
  value: any
}

export default BaseTextfield
